import React, { useEffect } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "aos/dist/aos.css";
import AOS from "aos";
import "react-accessible-accordion/dist/fancy-example.css";
import "./../../../HomePage/Faq/Faq.css";
const KuwaitMainFaq = () => {
  useEffect(() => {
    AOS.init({
      duration: 600,
    });
  }, []);
  return (
    <div className="faqMainContainer">
      <Accordion className="faqMainContent" allowZeroExpanded>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What is Kuwait Attestation and why is it required?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>

          <AccordionItemPanel className="faqPanel">
            <p>
              Kuwait Attestation is the official verification process for your
              documents—such as degree, marriage, birth, and commercial
              certificates—so they are legally accepted by the Kuwait
              Government. It is required for:
              <ul>
                <li> Employment Visa</li>
                <li> Family/Dependent Visa</li>
                <li> Higher Education</li>
                <li> Business Setup</li>
                <li> Residency Purposes</li>
              </ul>
              Without proper attestation, Kuwait authorities will not accept
              your documents.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>How long does Kuwait Attestation take in Bangalore?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Timelines depend on document type and verification level:
              <ul>
                <li>
                  {" "}
                  <b>Educational Certificates:</b> 7–12 working days
                </li>
                <li>
                  <b>Personal Certificates:</b> 10–15 working days
                </li>
                <li>
                  <b>Commercial Documents:</b> 10–18 working days
                </li>
              </ul>
              Express services can reduce processing time to 5–7 days.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What documents do I need for Kuwait Attestation?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              You may need:
              <ul>
                <li> Original certificate</li>
                <li> Passport copy</li>
                <li> Marksheet copies (for degree)</li>
                <li> Authorization letter (for agency)</li>
                <li> Visa copy (if available)</li>
                <li> Supporting documents (varies case-by-case)</li>
              </ul>
              Some personal documents may require local municipal or state
              verification.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Is it safe to give my original certificates to an agency?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes—only if you choose a Govt-approved, ISO-certified agency with
              a physical office. A genuine agency provides:
              <ul>
                <li> Document receipt</li>
                <li> Tracking number</li>
                <li> Secure handling</li>
                <li> Physical office verification</li>
              </ul>
              Avoid freelancers or WhatsApp-only agents.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>
                {" "}
                Can Kuwait Attestation be done without visiting the office?
              </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes. Many trusted agencies offer:
              <ul>
                <li> Free Home Pickup & Drop</li>
                <li> Doorstep document collection</li>
                <li> Secure online payment</li>
              </ul>
              This is convenient for professionals and those living far from
              city centers.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What is the cost of Kuwait Attestation in Bangalore?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Cost varies depending on document type and processing speed:
              <ul>
                <li> Degree Attestation: ₹5,000–₹12,000</li>
                <li> Marriage/Birth Certificates: ₹6,000–₹14,000</li>
                <li> Commercial Documents: ₹12,000–₹28,000</li>
              </ul>
              Prices may include Notary + State + MEA + Kuwait Embassy charges.
            </p>
          </AccordionItemPanel>
        </AccordionItem>

        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What are the steps involved in Kuwait Attestation?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              The complete process typically includes:
              <ul>
                <li>1. Home Pickup (optional)</li>
                <li>2. Notary Attestation</li>
                <li>3. State HRD/SDM/Home Department Attestation</li>
                <li>
                  4. MEA Attestation (Ministry of External Affairs, India)
                </li>
                <li>5. Kuwait Embassy Attestation (India)</li>
                <li>6. MOFA Attestation in Kuwait (if required)</li>
              </ul>
              A good agency handles all these steps seamlessly.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>
                How can I check if an attestation agency is genuine or not?{" "}
              </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Choose an agency that is:
              <ul>
                <li> Govt Approved & ISO Certified</li>
                <li> Has office with landline + verified address</li>
                <li> Offers tracking & receipt for documents</li>
                <li> Has processed 20,000+ documents</li>
                <li> Trusted by corporates/MNCs</li>
                <li> Provides transparent pricing</li>
              </ul>
              Avoid agents with no office or only WhatsApp communication.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Can Kuwait Attestation be done urgently?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes. Many agencies offer urgent attestation service:
              <ul>
                <li> Processing in 5–7 working days</li>
                <li> Priority handling</li>
                <li> Higher charges may apply</li>
              </ul>
              This is useful if your employer or consultant gives a short
              deadline.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        
      </Accordion>
    </div>
  );
};

export default KuwaitMainFaq;
